export default __webpack_public_path__ + "static/step-one-5a0bb2f34385a1fd0dd9e37ade880b23.svg";